var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-main-collection d-flex justify-center align-center"},[_c('div',{staticClass:"k-resource-report"},[_c('AdminResourceUsage')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }